module.exports = __webpack_public_path__ + "media/buko001.555fd65e.wav";